module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline form-multiselect"
  }, [_c('label', [_vm._v("Tagged with")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect-control"
  }, [_c('multiselect', {
    attrs: {
      "track-by": "name",
      "options": _vm.options,
      "multiple": true,
      "custom-label": _vm.tagLabelFormatter,
      "showLabels": false,
      "closeOnSelect": false,
      "disabled": !_vm.options.length,
      "placeholder": _vm.options.length ? 'Choose tag' : 'No tags available'
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17aa63d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TagsSearch.vue
// module id = 429
// module chunks = 1